import axios from 'axios'
import config from '../config';

import { getQueryStringFromObject, getRequestHeaders } from './common.service';

const allConsumptions = async () => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/all_consumptions', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getConsumptionList = async (query=null) => {
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/consumptions' + queryString, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getConsumptionDetails = async (consumption_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/consumptions/' + consumption_id, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const saveConsumption = async (consumption_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v1/consumptions/' + consumption_id, data, { headers: headers });
        }
        catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const deleteConsumption = async (consumption_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.delete( config.apiUrl + '/v1/consumptions/' + consumption_id, { headers: headers });
        }
        catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

export {
    getConsumptionList,
    getConsumptionDetails,
    saveConsumption,
    deleteConsumption,
    allConsumptions
}
